import { Phone, Mail } from "lucide-react";
import AppointmentForm from "./AppointmentForm";
import Reveal from "./Reveal";
import { useLang } from "../i18n/i18n";

export default function Contact({ settings }) {
  const { t } = useLang();
  const s = settings || {};

  return (
    <section id="contact" className="mx-auto max-w-7xl px-5 sm:px-8 py-24" data-testid="contact-section">
      <div className="grid gap-14 lg:grid-cols-2 items-start">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-gold">{t("contact.eyebrow")}</p>
          <h2 className="mt-4 font-display text-4xl sm:text-6xl font-light text-cream leading-tight">
            {t("contact.call")}
            <br />
            <a href={`tel:${s.phone || "514-378-8833"}`} data-testid="contact-phone-link" className="gold-text tabular">
              {s.phone || "514-378-8833"}
            </a>
          </h2>
          <a
            href={`mailto:${s.email || "estefanijewellery@gmail.com"}`}
            data-testid="contact-email-link"
            className="mt-8 inline-flex items-center gap-3 text-cream/70 hover:text-goldlight transition-colors"
          >
            <Mail size={18} className="text-gold" /> {s.email || "estefanijewellery@gmail.com"}
          </a>
          <div className="hairline my-10" />
          <p className="text-sm leading-relaxed text-mutedc max-w-md">{t("contact.privacy")}</p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="rounded-3xl border border-gold/20 bg-panel/70 backdrop-blur p-7 sm:p-9" data-testid="contact-appointment-panel">
            <h3 className="font-display text-2xl text-cream">{t("apt.formTitle")}</h3>
            <p className="mt-2 text-sm text-mutedc mb-6">{t("apt.formSub")}</p>
            <AppointmentForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
